<template>
    <div style="width: 100%; height: 100%">
        <div v-if="parmas.series" class="charts" ref="myChart" :parmas='parmas' style="width: 100%; height: 100%"></div>
        <dv-loading v-else>Loading...</dv-loading>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props: {
        parmas: {
            typeof: Object
        }
    },
    components: {

    },
    data() {
        return {
            chart: null,
        };
    },
    computed: {

    },
    watch: {
        parmas:{
            deep:true, //开启监听模式
            handler() {
                this.initCharts();
            },
            immediate: true
        }
    },
    created() {

    },
    mounted() {
        // this.mouseEvents()
    },
    methods: {
        initCharts() {
            this.$nextTick(() => {
                if(this.$refs.myChart) {
                    echarts.dispose(this.$refs.myChart)
                    let myChart = echarts.init(this.$refs.myChart)
                    this.chart = myChart.setOption(this.parmas)
                }
            })
        },
        resizeCharts() {
            this.$nextTick(() => {
                if(this.$refs.myChart) {
                    echarts.dispose(this.$refs.myChart)
                    let myChart = echarts.init(this.$refs.myChart)
                    myChart.resize();
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped >
:deep.dv-loading .loading-tip {
    color: #fff;
}
</style>